import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-recommended-products]',
};

class RecommendedProducts extends HTMLElement {
  constructor() {
    super();

    // Children aren't parsed yet during the initial page render, but they are
    // when the section gets re-rendered in the theme editor.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    // Products picked in the theme editor are already in the markup. Automatic
    // recommendations aren't — Shopify only populates them when the section is
    // requested through the Product Recommendations API, so go and get it.
    if (this.dataset.url) {
      this.loadRecommendations();
      return;
    }

    this.render();
  }

  loadRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const recommendations = html.querySelector('recommended-products');

        if (!recommendations || !recommendations.innerHTML.trim().length) return;

        this.innerHTML = recommendations.innerHTML;
        this.render();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  render() {
    if (!this.querySelector(selectors.carouselWrapper)) return;

    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(this.querySelector(selectors.carouselWrapper), {
      modules: [Navigation, Scrollbar],
      lazy: true,
      lazyPreloadPrevNext: 2,
      slidesPerView: 1.6,
      spaceBetween: 6,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 40,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.6,
          spaceBetween: 20,
        },
        744: {
          slidesPerView: 2.3,
          spaceBetween: 28,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 28,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 28,
        },
        1665: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('recommended-products', RecommendedProducts);
